module.exports = __webpack_public_path__ + "img/ALWAYSON-INSv4-CUST-LD.48b29a26.jpg";